
<template functional>
    <div :class="data.staticClass">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <div class="flex items-center p-3">
          <div>
            <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" :src="props.mailContent.user.photo  ? props.mailContent.base_url+props.mailContent.user.photo : require('@/assets/images/default-images/default-profile.png')" size="65px" />
          </div>
          <div class="flex flex-col">
            <h5 class="mb-1">{{ props.mailContent.user.firstname+' '+props.mailContent.user.lastname }}</h5>
            <div class="flex items-center">
              <span class="text-sm my-3">{{ props.mailContent.user.email }}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-end my-4">
          <span class="text-right my-3">{{ props.mailContent.date | formatMessageTime }}</span>
          <div>{{ props.mailContent.date | formatDate }}</div>
        </div>
      </div>
       <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mail__content break-words mt-8 mb-4" v-html="props.mailContent.body"></div>
      </div>
    </div>

    </div>
</template>

<script>
import { ApiKeys } from '@/keys';

export default {
  props: {
    mailContent: {
      type: Object,
      required: true
    }
  }
}
</script>

